module.exports = __webpack_public_path__ + "img/trial_rising_202410.e88b432e.jpg";